import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { ROUTES } from "~/router";
import AuthBanner, { BannerTypes } from "~/screens/Auth/components/AuthBanner";
import LoginForm from "~/screens/Auth/components/LoginForm";
import { AuthLayout } from "~/screens/Auth/Layout/AuthLayout";
import { Title, usePageTitle } from "~/shared";
import { useBookingFlowStore } from "~/stores";
import HighlightedText from "~/ui/common/HighlightedText";
import BackButton from "../components/BackButton";

interface LoginProps {
  allowSignup: boolean;
}

const QUALIFIER_QUESTIONS_SOURCE = "qualifier-questions";

export const Login = ({ allowSignup }: LoginProps) => {
  usePageTitle("Log in");
  const [searchParams] = useSearchParams();

  const source = searchParams.get("source");
  const isFromQualifierQuestions = source === QUALIFIER_QUESTIONS_SOURCE;
  const keepBookingFlow = searchParams.get("keepBookingFlow");
  const clearBookingFlow = useBookingFlowStore((state) => state.clear);

  useEffect(() => {
    if (!keepBookingFlow) {
      clearBookingFlow();
    }
  }, [keepBookingFlow, clearBookingFlow]);
  return (
    <AuthLayout
      banner={<AuthBanner type={BannerTypes.login} />}
      showSupport
      showMightyNetworks
      showProtectedByRecaptcha
    >
      <section className="flex w-full items-center justify-center">
        <div className="relative w-full max-w-lg bg-white pb-2">
          <section>
            {isFromQualifierQuestions && <BackButton to={ROUTES.getStarted} />}

            <div className="space-y-6">
              <Title>
                {isFromQualifierQuestions ? (
                  <>
                    <HighlightedText>Log in</HighlightedText> to continue
                  </>
                ) : (
                  <HighlightedText>Welcome back!</HighlightedText>
                )}
              </Title>

              <p className="text-sm font-normal text-neutral-800">
                (*) Mandatory field
              </p>
            </div>
          </section>

          <LoginForm />

          <section>
            {allowSignup && (
              <p className="mt-4 text-gray-600 md:text-left">
                Don’t have an account?{" "}
                <Link
                  to={ROUTES.signup}
                  className="text-indigo underline"
                  role="link"
                >
                  Sign up
                </Link>
              </p>
            )}
          </section>
        </div>
      </section>
    </AuthLayout>
  );
};
